import { useState, useEffect } from 'react';
import { portalService } from '../services/portalService';
import { connectionManagementService } from '../../../services/connectionManagementService';
import { useRegion } from '../../../shared/contexts/RegionContext';
import type { Collection } from '@amzn/aws-gcr-content-connection-management-client';

interface UseCollectionsReturn {
  collections: Collection[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useCollections = (): UseCollectionsReturn => {
  const [collections, setCollections] = useState<Collection[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { currentRegion } = useRegion();

  const fetchCollections = async () => {
    try {
      setLoading(true);
      setError(null);
      connectionManagementService.setRegion(currentRegion);
      const data = await portalService.getAllCollections();
      setCollections(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load collections');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollections();
  }, [currentRegion]);

  return { collections, loading, error, refetch: fetchCollections };
};
